import { Link } from "@remix-run/react";
import { InklusionCard } from "~/shared";
import theme from "~/theme/default";
import { classNames } from "~/utils";
import waveWhite from "~/assets/images/inkusion/wave-bg-top-white.svg";
import curvbackground from "~/assets/images/start_how_itworsk_wave.svg";

type Card = {
  id: number;
  title: string;
  description: string;
  anchor: string;
  icon?: string;
};

type InfoCardsMergedProps = {
  cards: Card[];
  title: string;
  body: string;
};

export const InfoCardsMerged = ({
  cards,
  title,
  body,
}: InfoCardsMergedProps) => {
  const { button } = theme;
  const { base, color } = button;

  // Take only first 4 cards
  const displayCards = cards.slice(0, 4);

  return (
    <div className="relative bg-gray-100 py-12 md:py-36">
      {/* Wave at top */}
      <div className="absolute top-0 z-40 hidden w-full md:block">
        <img alt="" className="z-50 w-full object-fill" src={curvbackground} />
      </div>

      <div className="section-wrapper">
        <div className="mt-6 flex flex-col gap-8 pb-28 lg:mt-14 lg:flex-row lg:gap-12">
          {/* Left column: InfoAboutRu content */}
          <div className="flex flex-1 flex-col ">
            <h3 className="text-3xl font-bold md:max-w-lg md:text-3xl lg:max-w-2xl lg:text-[40px] lg:leading-[1.1]">
              {title}
            </h3>

            <div className="mt-4 flex flex-col md:max-w-[550px]">
              <div>
                <div
                  className="pb-4 text-base text-primary lg:pb-5"
                  dangerouslySetInnerHTML={{
                    __html: body,
                  }}
                />
                {/* <Link
                  to="/search/main"
                  className={classNames(base, color.primary, "px-9")}
                >
                  Medien entdecken
                </Link> */}
              </div>
            </div>
          </div>

          {/* Right column: 4 cards in 2x2 grid */}
          <div className="flex-1">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {displayCards.map((card) => (
                <div key={card.id} className="mt-6">
                  <InklusionCard {...card} externalLinks />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Wave at bottom */}
      <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-40 hidden w-full md:block">
        <img
          alt="wave-white"
          className="z-40 w-full object-contain"
          src={waveWhite}
        />
      </div>
    </div>
  );
};
